<template>
  <div class="dui-tab-options">
    <div
      v-for="option in vm.options"
      :key="option.value"
      class="tab-option"
      :class="{
        'active': (isOptionsSelected(option.value)),
        'disabled': option.disabled
      }"
      :title="option.title"
      @click="optionSelected(option)"
    >
      <img
        :src="option.image"
        :style="{ top: option.topOverride }"
      >
      <h4>{{ option.title }}</h4>
      <p class="text-grey-dark">
        {{ option.description }}
      </p>

      <DuiIconTick class="icon-white" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [ String, Array ],
      default: null,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    vm: {
      selectedOption: null,
    },
  }),
  watch: {
    value: function(newVal) {
      this.setSelectedValue();
    },
  },
  mounted() {
    this.setSelectedValue();
  },
  methods: {
    isOptionsSelected(option) {
      if (!this.vm.selectedOption) return false;

      return this.isMultiple ? this.vm.selectedOption.includes(option) : this.vm.selectedOption === option;
    },
    optionSelected(option) {
      let newValue;

      if (typeof option.extraClickCallback === 'function') {
        option.extraClickCallback();
      }

      if (this.isMultiple) {
        if (this.vm.selectedOption.includes(option.value)) {
          newValue = this.vm.selectedOption.filter((val) => val !== option.value);
        } else {
          newValue = this.vm.selectedOption.concat(option.value);
        }
      }

      if (!this.isMultiple && (this.vm.selectedOption === option.value || option.disabled)) {
        return;
      }

      this.$set(this.vm, 'selectedOption', this.isMultiple ? newValue : option.value);
      this.$emit('input', this.vm.selectedOption);
      this.$emit('change');
    },

    setSelectedValue() {
      if (!this.value) {
        this.$set(this.vm, 'selectedOption', null);
        return;
      }

      this.$set(this.vm, 'selectedOption', this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-tab-options {
  @include screenMoreThan(sm) {
    display: flex;
  }

  .tab-option {
    background: getColor($white);
    border: $border-width-base solid getColor($grey, medium);
    border-radius: $border-radius-lg;
    margin: 0 0 $_2em 0;
    overflow: hidden;
    padding: $_2em;
    position: relative;
    text-align: center;

    @include transition((
      border-color,
      box-shadow
    ));

    &:hover,
    &.active {
      border-color: getColor($yellow);
    }

    &:hover {
      cursor: pointer;
    }

    &.disabled {
      filter: grayscale(1);
    }

    &.active {
      box-shadow: $box-shadow-sm;

      &:before,
      .dui-icon {
        opacity: 1;
      }

      &:before {
        transform: rotate(45deg) scale(1) translate3d(0,0,0);
      }

      .dui-icon {
        transform: scale(1);
      }
    }

    &:before,
    .dui-icon {
      content: " ";
      display: block;
      opacity: 0;
      position: absolute;
      z-index: 1;

      @include transition((
        opacity,
        transform
      ));
    }

    &:before {
      background-color: getColor($yellow);
      height: $_10em;
      right: -$_5em;
      transform: rotate(45deg) scale(0.1) translate3d(0,0,0);
      top: -$_5em;
      width: $_10em;
    }

    .dui-icon {
      right: $_1em;
      top: $_1em;
      transform: scale(0.1);
      z-index: 2;
    }

    h4 {
      margin-top: (2 * $_6em);
    }

    img {
      left: 50%;
      position: absolute;
      top: $_4em;
      transform: translateX(-50%);
    }

    p {
      margin: 0;
    }

    @include screenMoreThan(sm) {
      // display: inline-flex;
      flex-direction: column;
      margin: 0 0 0 $_2em;
      width: calc(50% - #{ $_5em + ($border-width-base * 2) });

      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
